import React from 'react';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { getApi } from '../utils/api';
import { packages } from '../utils/endpoint';
import { useState } from 'react';
import {
  getDisplayFrequency,
  getFirstPrepaidOption,
  getPlanOptions,
  getPrimaryPlanOption,
} from '../utils/planAdapter';

const Bill = (props) => {
  const [plan, setPlan] = useState({});
  const [planPackage, setPlanPackage] = useState(null);
  let packagePlanType = localStorage.getItem('selectedPlanType');
  const isMembership = localStorage.getItem('isMembershipActivate');
  useEffect(() => {
    const fetchData = async () => {
      getApi(packages)
        .then((res) => {
          const responseData = res?.data?.data;

          if (!Array.isArray(responseData) || responseData.length === 0) {
            return;
          }

          if (isMembership) {
            const prepaidSelection = getFirstPrepaidOption(responseData);

            if (prepaidSelection) {
              const selectedMembership = {
                ...prepaidSelection.option,
                name: prepaidSelection.option?.package_name,
                packageName: prepaidSelection.plan?.name,
              };

              localStorage.setItem(
                'selectedMembershipPlan',
                JSON.stringify(selectedMembership)
              );

              setPlanPackage(prepaidSelection.plan);

              let dataPrePaid = {
                packageName: prepaidSelection.plan?.name,
                name: prepaidSelection.option?.package_name,
                price: prepaidSelection.option?.price,
                id: prepaidSelection.option?.id,
                prepaid: prepaidSelection.option?.is_prepaid,
                activationFee: prepaidSelection.option?.activation_fees,
              };
              setPlan(dataPrePaid);
            }
          } else {
            const planData = responseData[0];
            setPlanPackage(planData);

            const filterPackage = packagePlanType ? packagePlanType : 'Monthly';
            const targetFrequency = getDisplayFrequency(filterPackage);
            const selectedOption = getPrimaryPlanOption(
              planData,
              targetFrequency,
              {
                includePrepaid: false,
                includeLifetimeFallback: true,
              }
            );

            if (selectedOption) {
              let data = {
                name: planData?.name,
                price: selectedOption?.price,
                id: planData?.id,
              };
              setPlan(data);
            }
          }
        })
        .catch((er) => {
          console.log(er);
        });
    };
    fetchData();
  }, []);

  const handlePlanTerm = () => {
    props?.setPlanInfo?.handlePlanSelection(!props?.setPlanInfo?.isPlan);
    if (!props.Yearly && planPackage) {
      let selectedOption = !props?.setPlanInfo?.isPlan ? 'Yearly' : 'Monthly';
      const getprice = getPlanOptions(planPackage, {
        includePrepaid: false,
      }).filter((resData) => resData.display_frequency === selectedOption);

      let data = {
        name: planPackage?.name,
        price: getprice[0]?.price,
        id: planPackage?.id,
      };
      setPlan(data);
    }
  };

  return (
    <>
      {plan && (
        <div className="">
          <h3 className="order-heading">{props.Heading}</h3>
          <div className="order-summary">
            <div className="cover-yearly">
              <h4>{props.Yearly ? props.Yearly : plan?.packageName}</h4>

              {props?.isTab &&
                props.PlanType !== '/ One-time' &&
                !plan?.prepaid && (
                  <div className="plan-select">
                    <p>
                      {props.Dollar ? props.Dollar : '$' + plan?.price}{' '}
                      {props.PlanType}
                    </p>
                    <div className="form-check form-switch">
                      <label
                        className="form-check-label m"
                        htmlFor="monthly"
                        style={{ textAlign: 'left' }}
                      >
                        Monthly
                      </label>
                      <input
                        className={`form-check-input ${
                          !props?.setPlanInfo?.isPlan ? 'month' : 'yearly'
                        }`}
                        type="checkbox"
                        id={!props?.setPlanInfo?.isPlan ? 'yearly' : 'monthly'}
                        onChange={handlePlanTerm}
                        checked={props?.setPlanInfo?.isPlan}
                      />
                      <label className="form-check-label" htmlFor="yearly">
                        Yearly
                      </label>
                    </div>
                  </div>
                )}
            </div>
            <div className="items-plan items-border-left-remove">
              <table className="table">
                <tbody>
                  <tr>
                    <td>
                      <p className="plan">
                        {plan?.prepaid ? plan?.name : props.PlanUser}
                      </p>
                    </td>
                    <td>
                      {plan?.prepaid ? (
                        <p className="price">
                          ( - {props.Price ? props.Price : '$' + plan?.price} )
                        </p>
                      ) : (
                        <p className="price">
                          {props.Price ? props.Price : '$' + plan?.price}
                        </p>
                      )}
                    </td>
                  </tr>
                  {/* <tr>
                <td>
                  <p className="plan">{props.Add}</p>
                </td>
                <td>
                  <p className="price1">{props.AddPrice}</p>
                </td>
              </tr> */}
                  <tr>
                    <td>
                      <p className="plan">
                        {plan?.prepaid ? 'Activation Fee ' : props.Time}
                      </p>
                    </td>
                    <td>
                      <p className="price1">
                        {plan?.prepaid
                          ? '$' + plan?.activationFee
                          : props.TimePrice}
                      </p>
                    </td>
                  </tr>
                  {/* {props.isAdditional && (
                <tr>
                  <td>
                    <p className="plan">{props.Additional}</p>
                  </td>
                  <td>
                    <p className="price1">{props.AdditionalPrice}</p>
                  </td>
                </tr>
              )} */}

                  <tr>
                    <td>
                      <p className="plan">{props.Tax}</p>
                    </td>
                    <td>
                      <p className="price1">{props.TaxPrice}</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <table className="table">
                <tbody>
                  <tr className="last-total">
                    <td>
                      <p className="total">{props.Total}</p>
                    </td>
                    <td>
                      <p className="all-total">
                        {props.TotalPrice
                          ? props.TotalPrice
                          : plan?.prepaid
                            ? '$' + plan?.activationFee
                            : '$' + parseFloat(plan?.price).toFixed(2)}
                      </p>
                      {/* <p className="all-total">
                        {props.TotalPrice
                          ? props.TotalPrice
                          : '$' + (parseFloat(plan?.price) + 20).toFixed(2)}
                      </p> */}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

Bill.propTypes = {
  props: PropTypes.object,
  Heading: PropTypes.string,
  Yearly: PropTypes.string,
  Dollar: PropTypes.string,
  PlanUser: PropTypes.string,
  PlanType: PropTypes.string,
  Price: PropTypes.string,
  Add: PropTypes.string,
  AddPrice: PropTypes.string,
  Time: PropTypes.string,
  TimePrice: PropTypes.string,
  Additional: PropTypes.string,
  AdditionalPrice: PropTypes.string,
  Tax: PropTypes.string,
  TaxPrice: PropTypes.string,
  Total: PropTypes.string,
  TotalPrice: PropTypes.string,
  isAdditional: PropTypes.bool,
  setPlanInfo: PropTypes.object,
  isTab: PropTypes.bool,
};
export default Bill;
